import { render, staticRenderFns } from "./playlists-scheduler.vue?vue&type=template&id=27c5c732&scoped=true"
import script from "./playlists-scheduler.vue?vue&type=script&lang=js"
export * from "./playlists-scheduler.vue?vue&type=script&lang=js"
import style0 from "./playlists-scheduler.vue?vue&type=style&index=0&id=27c5c732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5c732",
  null
  
)

export default component.exports